import axiosInstance from '../../../../config/axiosInstance';
const  LanguageService = {
    async GetClientLanguage(redirectCallback,ClientID) {
        try {            
            const response = await axiosInstance.get(`/Setup/GetClientLanguages?ClientID=${ClientID}`);
            return response.data[0];
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    }
};

export default LanguageService;